/* eslint-disable */
import { useState } from 'react';
import { useForm } from "react-hook-form";

let attribute_arr = [
    { "vals": "sales-status-Not Interested", "text": "Not Interested" },
    { "vals": "sales-status-Interested", "text": "Interested" },
    { "vals": "sales-status-Complete", "text": "Client" },
    { "vals": "sales-lead-Hot", "text": "Hot" },
    { "vals": "sales-lead-Warm", "text": "Warm" },
    { "vals": "sales-lead-Cold", "text": "Cold" },
]


export default function AllAtrribute({ event, setNodes, wa_authKey, waEmployee }) {
    const { register: all_att_reg } = useForm({ defaultValues: { attri: event.data.value.api.attributeDetails } });
    const [refresher, setRefresher] = useState(false);

    const rmAtt = (vals) => {
        const arr = event.data.value.api.agents.filter(t => t != vals);
        const uniqueArray = [...new Set(arr)];
        event.data.value.api.agents = uniqueArray;
        setRefresher(!refresher)
    }


    const addAgent = (vals) => {
        setNodes(nds => nds.map(node => {
            if (node.id === event.id) {
                let agentDetail = node.data.value.api.agents
                const uniqueArray = [...new Set([...agentDetail, vals])]
                node.data.value.api.agents = uniqueArray;
            }
            return node;
        }));
        setRefresher(!refresher);
    }

    const EmpListForAtt = () => {
        return (
            <select className="form-control" onChange={(e) => addAgent(e.target.value)}>
                <option value="" disabled selected>Select Agent</option>
                {Object.keys(waEmployee.data.data).map(i => waEmployee.data.data[`${i}`].map(x => <option value={x.empid}>{x.emp_name}({i})</option>))}
            </select>
        )
    }







    const att_assign = (val) => {
        setNodes(nds => nds.map(node => {
            if (node.id === event.id) {
                node.data.value.api.attributeDetails = val
                node.data.value.api.auth_key = wa_authKey
            }
            return node;
        }));
        
        setRefresher(!refresher);
    };

    const checker = (vals) => {
        return Object.keys(waEmployee.data.data).map(i => {
            return waEmployee.data.data[`${i}`].map(x => {
                if (x.empid == vals) {
                    return <button type="button" onClick={e => rmAtt(x.empid)}>{x.emp_name}({i})</button>
                }
            })
        })
    }


    const ShowAgent = () => {
        return event.data.value.api.agents.map(t => {
            return checker(t)
        })
    }

    return (
        <div className="card-body mt-0">
            <div className="contact_add_div">
                <div className="mx-auto">
                    <ShowAgent />
                    <EmpListForAtt />
                    <select {...all_att_reg("attri", { required: true, onChange: (e) => att_assign(e.target.value) })} className="form-control">
                        <option value="" disabled>Select Attribute</option>
                        {attribute_arr.map(x => <option key={x.vals} value={x.vals}>{x.text}</option>)}
                    </select>
                </div>
            </div>
        </div>
    )
}